// This file was generated by "make codegen/iam". DO NOT EDIT.

import { GET_BASE_PLAN as ACTION_MONDOO_BILLING_BILLINGMANAGER_GETBASEPLAN } from "~/lib/iam/actions/mondoo/billing/BillingManager/GetBasePlan/action";
import { GET_ORGANIZATION as ACTION_MONDOO_CAPTAIN_CAPTAIN_GETORGANIZATION } from "~/lib/iam/actions/mondoo/captain/Captain/GetOrganization/action";
import { LIST_USER_SPACES as ACTION_MONDOO_CAPTAIN_CAPTAIN_LISTUSERSPACES } from "~/lib/iam/actions/mondoo/captain/Captain/ListUserSpaces/action";
import { REGISTER_USER_ACTION as ACTION_MONDOO_POLICY_EXTENDEDHUB_REGISTERUSERACTION } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/RegisterUserAction/action";

export const allowedActions = [
  ACTION_MONDOO_BILLING_BILLINGMANAGER_GETBASEPLAN,
  ACTION_MONDOO_CAPTAIN_CAPTAIN_GETORGANIZATION,
  ACTION_MONDOO_CAPTAIN_CAPTAIN_LISTUSERSPACES,
  ACTION_MONDOO_POLICY_EXTENDEDHUB_REGISTERUSERACTION,
] as const;
